import React, {useState, useEffect, useRef} from "react"
import PropTypes from "prop-types"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
  Table,
  Row,
  Col, Input, Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container, Card, CardBody, CardTitle, CardText
} from "reactstrap"
import axios from "axios"
import * as url from "../../helpers/url_helper"
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Link, useHistory, useParams } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import MetaTags from 'react-meta-tags'; 
import AppraisalTimeline from "./AppraisalTimeline"
import Select from "react-select"

const PerformanceAgreementDetails = () => {
    const history = useHistory();
    const {id} = useParams()
    toastr.options = TOAST_OPTIONS;

    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    const [userId, setUserId] = useState('')
    
    const [employeeId, setEmployeeId] = useState('')
    const [employeeNo, setEmployeeNo] = useState('')
    const [employeeName, setEmployeeName] = useState('')
    const [employeeTitle, setEmployeeTitle] = useState('')
    const [employeeDept, setEmployeeDept] = useState('')

    const [documentNo, setDocumentNo] = useState('')
    const [selectedEmployee, setSelectedEmployee] = useState('')
    const [appraisalPeriodId, setAppraisalPeriodId] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [ipaId, setIPAId] = useState('')
    const [performanceYear, setPerformanceYear] = useState('')
    const [postingDate, setPostingDate] = useState([])
    const [convertToAppraisal, setConvertToAppraisal] = useState('No')
    const [supervisorId, setSupervisorId] = useState('')
    const [selectedSupervisor, setSelectedSupervisor] = useState('')
    const [supervisorComment, setSupervisorComment] = useState('')
    const [status, setStatus] = useState('')
    const [dateTimeCreated, setDateTimeCreated] = useState('')
    const [ipaLines, setIPALines] = useState([])

    const [lineId, setLineId] = useState('')
    const [objective, setObjective] = useState('')
    const [deliverable, setDeliverable] = useState('')
    const [weight, setWeight] = useState('')
    const [targetDate, setTargetDate] = useState([])

    const [approverId, setApproverId] = useState("")
    const [action, setAction] = useState('')
    const [comment, setComment] = useState('')

    const [jobLocationOptions, setJobLocationOptions]     = useState([])
    const [appraisalPeriodOptions, setAppraisalPeriodOptions]     = useState([])
    const [statusOptions, setStatusOptions]     = useState(['Open', 'Pending Approval', 'Closed'])
    const [modal_ipaline, setmodal_ipaline] = useState(false);
    const [st, setST] = useState(1)

    const [employeeOptions, setEmployeeOptions] = useState([])
    
    const removeBodyCss = () => {
        document.body.classList.add("no_padding");
    }
    const tog_ipaline = () => {
        setmodal_ipaline(!modal_ipaline);
        removeBodyCss();
    }

    const fetchData = async () => {
        axios.post(url.HRPAPERIODS, JSON.stringify({action:'filter'}), Config).then((r)=>{ setAppraisalPeriodOptions(r.data) }).catch((e)=>console.log(e))
        const dat = {
            id  : '',
            no  : '',
            nin : '',
            name: '',
            phone:'',
            sex : '',
            status:'',
            marital:'',
            dept: '',
            category: '',
            location: ''
           }
       
        const data = {
            id          : be.decryptId(id),
            startDate   : '',
            endDate     : '',
            employeeNo  : '',
            employeeName: '',
            documentNo  : '',
            deptId      : '',
            locationId  : '',
            status      : '',
            action      : 'filter'
        }
        try {
            setIsLoading(true)
            const x = await axios.post(`${url.HREMPLOYEESFILTER}`, JSON.stringify(dat), Config)
            let arr = [];
            (x.data || []).map((a)=>{ arr.push({'value':a.id, 'label':a.name}) })
            setEmployeeOptions(arr)
            const r = await axios.post(url.HRPERFORMANCEAGG, JSON.stringify(data), Config)
            if(r.data[0]){
                const d = r.data[0]
                setEmployeeNo(d.emp_number)
                setEmployeeId(d.employee_id)
                setEmployeeName(d.emp_title+' '+d.first_name+' '+d.surname)
                setEmployeeTitle(d.title)
                setEmployeeDept(d.department)
                setDocumentNo(d.document_no)
                setAppraisalPeriodId(d.appraisal_period_id)
                setTitle(d.ipas_title)
                setDescription(d.ipas_description)
                setPerformanceYear(d.performance_year)
                setPostingDate(d.posting_date)
                setConvertToAppraisal(d.convert_to_appraisal)
                setSelectedSupervisor(arr.find(option => option.value == d.supervisor_id))
                setStatus(d.ipas_status)
                setDateTimeCreated(d.ipas_created_at)
                setIPALines(d.ipa_lines)
                setApproverId(d.approver_id)
                if(d.ipas_status == 'Closed'){ 
                    setST(3) 
                } else if(d.ipas_status == 'Pending Approval'){
                    setST(2)
                } else {
                    setST(1) 
                }
            }
        } catch (e) {
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
        }
        fetchData();
    },[]);
    const handleSaveLine = async () =>{
        const data = {
            id: isEdit?lineId:'',
            ipaId: be.decryptId(id),
            objective: objective,
            deliverable: deliverable,
            weight: weight,
            targetDate: formatDate(targetDate),
            action: isEdit?'update':'add'
        }
        try {
            setIsLoading(true)
            const r = await axios.post(url.HRIPERFORMANCEAGGLINES, JSON.stringify(data), Config)
            if(r.data.status == 1){
                toastr.success(r.data.message)
                tog_ipaline()
                setObjective('')
                setDeliverable('')
                setWeight('')
                setTargetDate([])
                fetchData()
            }else{
                toastr.error(r.data.message)
            }
        } catch (e) {
            console.error(e)
        } finally {
            setIsLoading(false)
        }
    }
    const handleApproval = async () =>{
        if(action == ""){
            toastr.error('You can select Approve or Reject')
        }else{
            if((action == "Reject") && (comment.trim().length < 4)){
                toastr.error("Please state reason for rejecting")
            }else{
                try {
                    const data = {
                        action  : action, 
                        entity  : 'IPA', 
                        no      : documentNo,
                        id      : be.decryptId(id), 
                        userId  : userId, 
                        comment : comment,
                        approver: approverId
                    }
                    setIsLoading(true)
                    const r = await axios.post(url.SENDAPPROVALREQUEST, JSON.stringify(data), Config)
                    if(r.data.status == 1){
                        toastr.success(r.data.message)
                        history.push('/Notifications')
                    }else{
                        toastr.error(r.data.message)
                    }
                } catch (e) {
                    console.log(e)
                } finally {
                    setIsLoading(false)
                }
            }
        }
    }
    const handleSendForApproval = async () =>{
        try {
            const data = {
                action  : 'request',
                entity  : 'IPA', 
                no      : documentNo,
                id      : be.decryptId(id), 
                userId  : userId,
                approver: approverId
            }
            setIsLoading(true)
            const r = await axios.post(url.SENDAPPROVALREQUEST, JSON.stringify(data), Config)
            console.log(r)
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData()
            }else{
                toastr.error(r.data.message)
            }
        } catch (e) {
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }
    const handleConvertToAppraisal = async () =>{
        try {
            const data = { ipaId : be.decryptId(id) }
            setIsLoading(true)
            const r = await axios.post(url.HRIPA2APPRAISAL, JSON.stringify(data), Config)
            if(r.data.status == 1){
                toastr.success(r.data.message)
                fetchData()
            }else{
                toastr.error(r.data.message)
            }
        } catch (e) {
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <>
        <LoadingOverlay
            active={isLoading}
            spinner={<BounceLoader />}
            text='Please wait...' >
            <div className="page-content">
                <MetaTags>
                <title>Performance Agreement Details | {url.COMPANY}</title>
                </MetaTags>
                <Container fluid={true}>
                    <div>
                        <Row>
                        <Modal isOpen={modal_ipaline} toggle={() => { tog_ipaline(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`} Performance Agreement Line</h5>
                                    <button type="button"  onClick={() => { setmodal_ipaline(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Objective</label>
                                                <input className="form-control" type='text' value={objective} onChange={(e)=>setObjective(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Deliverables</label>
                                                <textarea rows={5} className="form-control" value={deliverable} onChange={(e)=>setDeliverable(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Weight</label>
                                                <input className="form-control" type='number' value={weight} onChange={(e)=>setWeight(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col xl={6}>
                                            <div className="mb-3">
                                                <label>Target date</label>
                                                <Flatpickr
                                                    className="form-control"
                                                    options={{
                                                        dateFormat: "Y-m-d",
                                                        enableTime: false
                                                    }}
                                                    value={targetDate}
                                                    onChange={(dates)=>{setTargetDate(dates); }}
                                                    />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={handleSaveLine}  >Save...</button> )
                                }</div>
                                </Modal> 

                            <Col  xl={4}>
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">Employee Details</h6>
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Employee No</label>
                                                <input type='text' className="form-control" disabled={true} defaultValue={employeeNo} />
                                            </div>
                                        </Col> 
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Employee Name</label>
                                                <input type='text' className="form-control" disabled={true} defaultValue={employeeName} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Employee Title</label>
                                                <input type='text' className="form-control" disabled={true} defaultValue={employeeTitle} />
                                            </div>
                                        </Col> 
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Department</label>
                                                <input type='text' className="form-control" disabled={true} defaultValue={employeeDept} />
                                            </div>
                                        </Col>   
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Timeline</h6>
                                    <CardBody>
                                        <Row>
                                        <AppraisalTimeline stage={st}/>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl={8}>
                                <Card>
                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Employee Performance Agreement Details</h6>
                                    <CardBody>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Document No</label>
                                                    <input className='form-control' type='text' defaultValue={documentNo} disabled={true}/>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Appraisal Period</label>
                                                    <select className="form-select" value={appraisalPeriodId} disabled={(status == 'Open')?false:true} onChange={(e)=>setAppraisalPeriodId(e.target.value)}>
                                                    <option value=""></option>
                                                        {(appraisalPeriodOptions || []).map((d,k)=>(
                                                        <option key={k} value={d.id}>{d.name} - {d.status}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </Col>
                                            
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <label>Title</label>
                                                    <input className="form-control" type='text' disabled={(status == 'Open')?false:true} value={title} onChange={(e)=>setTitle(e.target.value)} />
                                                    
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <label>Description</label>
                                                    <input className="form-control" type='text' disabled={(status == 'Open')?false:true} value={description} onChange={(e)=>setDescription(e.target.value)} />
                                                    
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Performance Year</label>
                                                    <input className="form-control" type='number' disabled={(status == 'Open')?false:true} value={performanceYear} onChange={(e)=>setPerformanceYear(e.target.value)} />
                                                </div>
                                            </Col>
                                            <Col xl={6}>
                                                <div className="mb-3">
                                                    <label>Posting Date</label>
                                                    <Flatpickr
                                                        className="form-control"
                                                        options={{
                                                            dateFormat: "Y-m-d",
                                                            enableTime: false
                                                        }}
                                                        value={postingDate}
                                                        onChange={(dates)=>{setPostingDate(dates); }}
                                                        disabled={(status == 'Open')?false:true}
                                                        />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Convert to Appraisal</label>
                                                    <select className="form-select" disabled={true} value={convertToAppraisal} onChange={(e)=>setConvertToAppraisal(e.target.value)} >
                                                    <option value=""></option>
                                                    <option value="No">No</option>
                                                    <option value="Yes">Yes</option>
                                                    </select>
                                                    
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Supervisor</label>
                                                    <Select value={selectedSupervisor} isDisabled={(status == 'Open')?false:true} onChange={(oo)=>{setSelectedSupervisor(oo);  }} options={employeeOptions} isSearchable/>
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <label>{`Supervisor's Comment on this performance agreement`}</label>
                                                    <textarea className="form-control" disabled={(status == 'Pending Approval')?false:true} rows={5} value={supervisorComment} onChange={(e)=>{setSupervisorComment(e.target.value)}} />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Status</label>
                                                    <select className="form-select" disabled={true} value={status} onChange={(e)=>setStatus(e.target.value)} >
                                                    <option value=""></option>
                                                        {(statusOptions || []).map((d,k)=>(
                                                        <option key={k} value={d}>{d}</option>
                                                        ))}
                                                    </select>
                                                    
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Date time created</label>
                                                    <input className="form-control" type='text' defaultValue={dateTimeCreated} disabled={true} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card>
                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Performance Agreement Lines</h6>
                                    <CardBody>
                                    <Row className="justify-content-center">
                                
                                {((ipaLines || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Objective</th>
                                            <th>Deliverable</th>
                                            <th>Weight</th>
                                            <th>Target date</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(ipaLines || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.objective}</td>
                                                <td>{l.deliverable}</td>
                                                <td>{l.weight}</td>
                                                <td>{l.target_date}</td>
                                                {(status == 'Open') && (
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => {setIsEdit(true); setLineId(l.ipa_line_id); setObjective(l.objective); setDeliverable(l.deliverable); setWeight(l.weight); setTargetDate([new Date(l.target_date)]); tog_ipaline()} }
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        //onClick={() => handleDeleteJobH(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                )}
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Performance Lines set</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    {(status == 'Open') && (
                                    <div className="col-auto">
                                        <Button color="primary" className="btn-sm btn-rounded" 
                                        onClick={() =>{ tog_ipaline(); setIsEdit(false); setObjective(''); setDeliverable(''), setTargetDate([]); setWeight('')  }}
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Performance Line</span></Button>
                                    </div> 
                                    )}
                                    </Row>
                                    </CardBody>
                                </Card>
                                {/*(userId == appraiseeId)*/} 
                                <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Actions by appraisee</h5>
                                <CardBody>
                                    <Row className="mb-2 mt-3 justify-content-center">
                                        {(status == 'Open') && (
                                            <>
                                                <Col md={5} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="danger" className="btn btn-rounded"  >
                                                            Delete Performance Agreement
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col md={5} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="success" className="btn btn-rounded" onClick={handleSendForApproval}  >
                                                            Send to Supervisor for Approval
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </>
                                        )}
                                        {(status == 'Pending Approval') && (
                                            <>
                                                <Col md={5} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="danger" className="btn btn-rounded" >
                                                            Cancel Approval Request
                                                        </Button>
                                                    </div>
                                                </Col>
                                                
                                            </>
                                        )}
                                        {(status == 'Closed') && (convertToAppraisal == 'No')?(
                                            <>
                                                <Col md={5} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="warning" className="btn btn-rounded" onClick={handleConvertToAppraisal} >
                                                            Convert to Appraisal
                                                        </Button>
                                                    </div>
                                                </Col>
                                                
                                            </>
                                        ):(
                                            <>
                                                <Col md={5} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <h4>Converted To Appraisal</h4>
                                                    </div>
                                                </Col>
                                                
                                            </>
                                        )}
                                        
                                </Row>
                                    </CardBody>
                                </Card>
                            

                              {(status == 'Pending Approval') && (userId == approverId) && (
                                    <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase">Actions by Supervisor</h5>
                                        <CardBody>
                                            <Row className="mb-2 mt-3 justify-content-center">
                                                <Col md={10} className='mb-2'>
                                                    <div className="mb-3">
                                                        <label>Action</label>
                                                        <select className="form-select" value={action} onChange={(e)=>setAction(e.target.value)}>
                                                            <option value=""></option>
                                                            <option value="Approve">Approve</option>
                                                            <option value="Reject">Reject</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col md={10} className='mb-2'>
                                                    <div className="mb-3">
                                                        <label>Comment</label>
                                                        <textarea className="form-control" value={comment} onChange={(e)=>setComment(e.target.value)} />
                                                    </div>
                                                </Col>
                                                <Col md={6} className='mb-3'>
                                                    <div className="d-grid gap-2">
                                                        <Button color="primary" className="btn" onClick={handleApproval}>
                                                            Submit response...
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                )} 
                                </Col>
                        </Row>
                   
                    </div>
                </Container>  
            </div>
            </LoadingOverlay>
        </>
    );
}

export default PerformanceAgreementDetails;